import {
    VEHICLE_CONFIG_FETCH,
    VEHICLE_CONFIG_BRAND,
    VEHICLE_CONFIG_CITY,
    VEHICLE_CONFIG_VEHICLE,
    VEHICLE_CONFIG_SPECIAL_CATEGORY,
    JOB_CONFIG_JOB_TYPES_FETCH,
    AGENCY_CONFIG_COMPANY,
    GALLERY_CONFIG_WORKING_CONTEXT,
    JOB_CONFIG_FAVOURITE_JOBS_FETCH,
    VEHICLE_CONFIG_FAVOURITE_VEHICLES_FETCH,
    GALLERY_CONFIG_USER_GALLERIES,
    AGENCY_CONFIG_USER_AGENCIES
} from './constants';
import {getVehicleAdConfigs} from '../services/configs'
import {
    getVehicleBrands,
    getValidVehicles,
    getCities,
    getSpecialCategories
} from '../services/vehicle'

export const startFetchVehicleConfigs = () => {
    return (dispatch, getState) => {
        return getVehicleAdConfigs({
            header: {
                Authorization: `Token ${getState().auth.token}`
            }
        })
        .then((response) => {
            dispatch(fetchVehicleConfigs(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            };
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            };
        })
    }
}

export const fetchVehicleConfigs = (payload) => ({
    type: VEHICLE_CONFIG_FETCH,
    payload
});

export const fetchJobTypes = (payload) => ({
    type: JOB_CONFIG_JOB_TYPES_FETCH,
    payload
});

export const fetchAgencyCompanies = (payload) => ({
    type: AGENCY_CONFIG_COMPANY,
    payload
});

export const fetchWorkingContexts = (payload) => ({
    type: GALLERY_CONFIG_WORKING_CONTEXT,
    payload
});

export const fetchFavouriteJobIds = (payload) => ({
    type: JOB_CONFIG_FAVOURITE_JOBS_FETCH,
    payload
});

export const fetchFavouriteAdIds = (payload) => ({
    type: VEHICLE_CONFIG_FAVOURITE_VEHICLES_FETCH,
    payload
});

export const fetchUserGalleries = (payload) => ({
    type: GALLERY_CONFIG_USER_GALLERIES,
    payload
});

export const fetchUserAgencies = (payload) => ({
    type: AGENCY_CONFIG_USER_AGENCIES,
    payload
});

export const startgetVehicleBrands = (id='0') => {
    return (dispatch, getState) => {
        return getVehicleBrands({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            parameter: {
                category: id
            }
        })
        .then((response) => {
            dispatch(fetchVehicleBrands(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchVehicleBrands = (payload) => ({
    type: VEHICLE_CONFIG_BRAND,
    payload
});

export const startgetCitiesOfState = (id='0') => {
    return (dispatch, getState) => {
        return getCities({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            parameter: {
                state: id
            }
        })
        .then((response) => {
            dispatch(getCitiesOfState(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const getCitiesOfState = (payload) => ({
    type: VEHICLE_CONFIG_CITY,
    payload
});

export const startgetValidVehicle = (brand='0', category='0') => {
    let params = {}
    if (brand !== '0'){
        params.brand = brand
    }
    if (category !== '0') {
        params.category = category
    }
    return (dispatch, getState) => {
        return getValidVehicles({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            parameter: params
        })
        .then((response) => {
            dispatch(fetchValidVehicles(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchValidVehicles = (payload) => ({
    type: VEHICLE_CONFIG_VEHICLE,
    payload
});

export const startgetSpecialCategories = (category='0') => {
    return (dispatch, getState) => {
        return getSpecialCategories({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            parameter: {
                category
            }
        })
        .then((response) => {
            dispatch(fetchSpecialCategories(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchSpecialCategories = (payload) => ({
    type: VEHICLE_CONFIG_SPECIAL_CATEGORY,
    payload
});